import { render, staticRenderFns } from "./ChannelIdReg.vue?vue&type=template&id=1d431b23"
import script from "./ChannelIdReg.vue?vue&type=script&lang=js"
export * from "./ChannelIdReg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports